let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8wxFC")).then(() => parcelRequire('1H3iv'));